export default __webpack_public_path__ + "static/media/image-3.0235cb65.svg";